import sizes from './sizes';

const layout = {
    tabletOrDesktop: (block) =>
        `@media (min-width: 1024px) and (min-height: 768px), (min-width: 768px) and (min-height: 1024px) {
            ${block}
        }`,
    bigScreens: (block) =>
        `@media (min-width: ${sizes.smallViewportDimensionPlusOne}) and (min-height: ${sizes.smallViewportDimensionPlusOne}) {
            ${block}
        }`,
    smallScreens: (block) =>
        `@media (max-width: ${sizes.smallViewportDimension}), (max-height: ${sizes.smallViewportDimension}) {
            ${block}
        }`,
    verySmallScreens: (block) =>
        `@media (max-width: ${sizes.verySmallViewportDimension}), (max-height: ${sizes.verySmallViewportDimension}) {
            ${block}
        }`,
    smallWidth: (block) =>
        `@media (max-width: ${sizes.smallViewportDimension}) {
            ${block}
        }`,
    smallHeight: (block) =>
        `@media (max-height: ${sizes.smallViewportDimension}) {
            ${block}
        }`,
    landscape: (block) =>
        `@media (orientation: landscape) {
            ${block}
        }`,
    portrait: (block) =>
        `@media (orientation: portrait) {
            ${block}
        }`,
};


export default layout;




// WEBPACK FOOTER //
// ./src/style/layout.js